import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import {
  ModalStyled,
  ModalBackgroundStyled,
} from "Components/common/ModalComponent/styles";
import { emergencyStopFleet } from "Slices/missionsPage/actions";

const EmergencyStopButtonStyled = styled.button`
  background: #b71c1c;
  color: #ffffff;
  height: 48px;
  padding: 0 12px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: "Readex Pro", sans-serif;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    background: #c62828;
  }
`;

const EmergencyStopModalStyled = styled.div`
  width: 400px;
  background: #172a3f;
  border-radius: 4px;
  padding: 24px;
  color: #ffffff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ModalTitleStyled = styled.div`
  font-family: "Readex Pro", sans-serif;
  font-size: 20px;
  font-weight: 700;
`;

const ModalBodyStyled = styled.div`
  font-size: 14px;
  color: #b0bec5;
  line-height: 1.5;
`;

const ModalActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 8px;
`;

const CancelButtonStyled = styled.button`
  background: transparent;
  color: #3f7f7d;
  border: none;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 8px 16px;
  &:hover {
    opacity: 0.8;
  }
`;

const ConfirmStopButtonStyled = styled.button`
  background: transparent;
  color: #ef5350;
  border: 2px solid #ef5350;
  border-radius: 4px;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 8px 16px;
  &:hover {
    opacity: 0.8;
  }
`;

interface EmergencyStopButtonProps {
  fleetId: string;
}

export const EmergencyStopButton = ({ fleetId }: EmergencyStopButtonProps) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirm = () => {
    dispatch(emergencyStopFleet({ fleetId }));
    setIsModalOpen(false);
  };

  return (
    <>
      <EmergencyStopButtonStyled onClick={() => setIsModalOpen(true)}>
        Cancel All Missions
      </EmergencyStopButtonStyled>

      {isModalOpen && (
        <ModalStyled>
          <ModalBackgroundStyled onClick={() => setIsModalOpen(false)} />
          <EmergencyStopModalStyled>
            <ModalTitleStyled>Cancel All Missions</ModalTitleStyled>
            <ModalBodyStyled>
              This will immediately cancel ALL active and queued missions for
              the entire fleet. This action cannot be undone.
            </ModalBodyStyled>
            <ModalActionsStyled>
              <CancelButtonStyled onClick={() => setIsModalOpen(false)}>
                Close
              </CancelButtonStyled>
              <ConfirmStopButtonStyled onClick={handleConfirm}>
                Cancel All Missions
              </ConfirmStopButtonStyled>
            </ModalActionsStyled>
          </EmergencyStopModalStyled>
        </ModalStyled>
      )}
    </>
  );
};
